export const EndPoint = {
  authLocal: "/auth/local",
  userProfile: "/UserProfile",
  userOrganizations: "/UserOrganizations",
  userApps: "/UserApps",
  userAppRedirect: "/UserAppRedirect",
  refreshAndRedirect: "/RefreshAndRedirect",
  changePassword: "/users/me/password/change",
  passwordReset: "/auth/password/reset",
  passwordResetRequest: "/auth/password/reset/request",
  passwordResetValidateOtp: "/auth/password/reset/validate-otp",
};
